import React, {useEffect, useState} from 'react';
import {useField, useFormikContext} from 'formik';

import {Column, Row} from '../layout';
import AppTextInput from '../input/app-text-input';
import ErrorMessage from './ErrorMessage';
import './styles.scss';
import passwordEyeHide from '../../assets/password-eye.svg';
import passwordEyeVisibleCrossed from '../../assets/password-eye-visible-crossed.svg';
import passwordEyeVisibleNotCrossed from '../../assets/password-eye-visible-not-crossed.svg';

interface AppFormFieldProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  showErrorMessage?: boolean;
  handleFormikContext?(formik: any): void;
  className?: string;
  modifyDisplayValue?(value: string): string;
  error?: string;
  onChange?(value: any): void;
  autoComplete?: string;
  clearStyle?: boolean;
  passwordIcon?: boolean;
  handlePasswordIconClick?(): void;
  showPassword?: boolean;
  pwdIconClass?: string;
}

function AppFormField({
  name,
  showErrorMessage = false,
  handleFormikContext,
  className,
  modifyDisplayValue,
  error,
  onChange,
  autoComplete,
  clearStyle,
  passwordIcon,
  handlePasswordIconClick,
  showPassword,
  pwdIconClass,
  ...rest
}: AppFormFieldProps) {
  const formik = useFormikContext();
  const [field] = useField(name);
  const [value, setValue] = useState(
    modifyDisplayValue ? modifyDisplayValue(field.value) : field.value
  );
  const [modify, setModify] = useState(true);
  const {setFieldTouched, handleChange, errors, touched} = formik;
  const newError = error ? error : (errors as any)[name];
  const visible = (touched as any)[name];

  useEffect(() => {
    if (!!modifyDisplayValue) {
      if (modifyDisplayValue(field.value) !== value) {
        setValue(field.value);
      }
    } else if (field.value !== value) {
      setValue(field.value);
    }
  }, [field.value]);

  if (!!handleFormikContext) {
    handleFormikContext(formik);
  }

  return (
    <>
      {!passwordIcon ? (
        <Column className={!clearStyle ? 'app-form-field-column-content' : ''}>
          <AppTextInput
            autoComplete={autoComplete}
            className={className}
            value={modify ? value : field.value}
            onChange={
              onChange
                ? (value) => {
                    onChange(value);
                    handleChange(name);
                  }
                : handleChange(name)
            }
            onClick={() => setModify(false)}
            onBlur={() => {
              setFieldTouched(name);
              if (modifyDisplayValue) {
                setValue(modifyDisplayValue(value));
              }
              setModify(true);
            }}
            error={error ? newError : newError && visible}
            {...rest}
          />
          {showErrorMessage && (
            <ErrorMessage error={newError} visible={visible} />
          )}
        </Column>
      ) : (
        <Column className={!clearStyle ? 'app-form-field-column-content' : ''}>
          <AppTextInput
            autoComplete={autoComplete}
            className={className}
            value={modify ? value : field.value}
            error={error ? newError : newError && visible}
            onChange={
              onChange
                ? (value) => {
                    onChange(value);
                    handleChange(name);
                  }
                : handleChange(name)
            }
            onClick={() => setModify(false)}
            onBlur={() => {
              setFieldTouched(name);
              if (modifyDisplayValue) {
                setValue(modifyDisplayValue(value));
              }
              setModify(true);
            }}
            {...rest}
          />
          {passwordIcon && field.value ? (
            <img
              className={pwdIconClass ? pwdIconClass : 'password-eye'}
              onClick={handlePasswordIconClick}
              src={
                !showPassword
                  ? passwordEyeVisibleCrossed
                  : passwordEyeVisibleNotCrossed
              }
            />
          ) : (
            <img
              className={pwdIconClass ? pwdIconClass : 'password-eye'}
              src={passwordEyeHide}
            />
          )}
          {showErrorMessage && (
            <Row>
              <ErrorMessage error={newError} visible={visible} />
            </Row>
          )}
        </Column>
      )}
    </>
  );
}

export default AppFormField;
